export const MAKE_OFFER = 'makeOffer';
export const CONTACT_SELLER = 'contactSeller';
